import React from 'react';
import { LazyImage } from 'react-lazy-images';

const CDN_PATH = 'https://cdn.heydoctor.com';

interface CdnImageProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  path?: string;
  minWidth?: number;
  minHeight?: number;
  border?: string;
}

export const CdnImage = ({ path, src, minWidth = 10, minHeight = 10, alt, style, ...props }: CdnImageProps) => (
  <LazyImage
    src={src || `${CDN_PATH}/${path}`}
    alt={alt}
    placeholder={({ ref }) => (
      <div ref={ref} style={{ minWidth: style?.width || minWidth, minHeight: style?.height || minHeight }} />
    )}
    actual={({ imageProps }) => <img alt={alt} {...imageProps} style={style} {...props} />}
  />
);
